import { deserializeXY } from "../../serialization";
import type { XY } from "../../xy";
import { ZOrder } from "../../zOrder";
import { Floor } from "./floor";

export class MetalGridFloor extends Floor {
	static key = "MetalGridFloor";
	constructor(xy: XY) {
		super(xy);
	}

	getZOrder(): number {
		return ZOrder.CARPET_LIKE;
	}

	isHideUnderneath(): boolean {
		return false;
	}

	static deserialize(data: any): MetalGridFloor {
		const f = new MetalGridFloor(deserializeXY(data.xy));
		f.visualId = data.visualId;
		return f;
	}
}
